export const useValidation = () => {
  const isRequiredTenDigits = (value) => {
    if (value) {
      if (value.replace(/ /g, '').replace(/-/g, '').length < 10) {
        return 'Tu número debe tener 10 números.';
      }
      return true;
    }
    return 'Tu número debe tener 10 números.';
  };

  return {
    isRequiredTenDigits
  };
};
